import React from 'react';
import Icon from '../../../components/AppIcon';

const StockStatsCards = ({ stats }) => {
  const statsCards = [
    {
      title: 'Total de Productos',
      value: stats.totalProducts,
      icon: 'Package',
      color: 'primary',
      change: stats.totalProductsChange,
      changeType: stats.totalProductsChange >= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Stock Bajo',
      value: stats.lowStockProducts,
      icon: 'AlertTriangle',
      color: 'warning',
      change: stats.lowStockChange,
      changeType: stats.lowStockChange <= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Sin Stock',
      value: stats.outOfStockProducts,
      icon: 'AlertCircle',
      color: 'error',
      change: stats.outOfStockChange,
      changeType: stats.outOfStockChange <= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Valor Total',
      value: `€${stats.totalValue.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`,
      icon: 'Euro',
      color: 'success',
      change: stats.totalValueChange,
      changeType: stats.totalValueChange >= 0 ? 'positive' : 'negative'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return {
          bg: 'bg-primary-50',
          icon: 'text-primary',
          border: 'border-primary-100'
        };
      case 'warning':
        return {
          bg: 'bg-warning-50',
          icon: 'text-warning',
          border: 'border-warning-100'
        };
      case 'error':
        return {
          bg: 'bg-error-50',
          icon: 'text-error',
          border: 'border-error-100'
        };
      case 'success':
        return {
          bg: 'bg-success-50',
          icon: 'text-success',
          border: 'border-success-100'
        };
      default:
        return {
          bg: 'bg-secondary-50',
          icon: 'text-secondary',
          border: 'border-secondary-100'
        };
    }
  };

  const formatChange = (change, isPercentage = true) => {
    if (change === 0) return '0%';
    const sign = change > 0 ? '+' : '';
    return `${sign}${change.toFixed(1)}${isPercentage ? '%' : ''}`;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statsCards.map((card, index) => {
        const colorClasses = getColorClasses(card.color);
        
        return (
          <div
            key={index}
            className={`bg-surface rounded-lg border ${colorClasses.border} p-6 hover:shadow-card transition-micro`}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm font-body-medium text-text-secondary mb-1">
                  {card.title}
                </p>
                <p className="text-2xl font-heading-semibold text-text-primary">
                  {card.value}
                </p>
                
                {/* Change Indicator */}
                {card.change !== undefined && (
                  <div className="flex items-center mt-2">
                    <Icon
                      name={card.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'}
                      size={14}
                      className={`mr-1 ${
                        card.changeType === 'positive' ? 'text-success' : 'text-error'
                      }`}
                    />
                    <span
                      className={`text-xs font-body-medium ${
                        card.changeType === 'positive' ? 'text-success' : 'text-error'
                      }`}
                    >
                      {formatChange(card.change)}
                    </span>
                    <span className="text-xs text-text-muted ml-1">
                      vs mes anterior
                    </span>
                  </div>
                )}
              </div>
              
              {/* Icon */}
              <div className={`w-12 h-12 ${colorClasses.bg} rounded-lg flex items-center justify-center`}>
                <Icon
                  name={card.icon}
                  size={24}
                  className={colorClasses.icon}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StockStatsCards;